import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";
import type { CalloutType } from "./type";

const THEME_MAP = {
  tip: {
    color: "#275e43",
    backgroundColor: "#d1e0d9",
    textTransform: "capitalize" as const,
  },
  important: {
    color: "#980b29",
    backgroundColor: "#f0c4cd",
    textTransform: "capitalize" as const,
  },
  fyi: {
    color: "#36485c",
    backgroundColor: "#e6edf5",
    textTransform: "uppercase" as const,
  },
};

export const callout = (type: CalloutType) => (theme: Theme) => {
  const typeTheme = THEME_MAP[type];
  return css({
    display: "flex",
    gap: "0.5rem",
    padding: "1rem",
    paddingInline: "1rem",
    marginBottom: "1.5rem",
    borderRadius: "0.5rem",
    color: typeTheme.color,
    backgroundColor: typeTheme.backgroundColor,
    fontSize: theme.aviaryTypography.body.fontSize,
    lineHeight: theme.aviaryTypography.body.lineHeight,
  });
};

export const content = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
});

export const title = (type: CalloutType) => () => {
  const typeTheme = THEME_MAP[type];

  return css({
    fontWeight: typography.weightSemiBold,
    textTransform: typeTheme.textTransform,
  });
};

export const iconContainer = css({
  paddingTop: "0.2rem",
  width: "1rem",
  minWidth: "1rem",
  maxWidth: "1rem",
  height: "1rem",
});

export const icon = css({
  fontSize: "1.25rem",
});
